module.exports = __webpack_public_path__ + "static/media/S (128).b79aa624.jpg";